// UpsellModal.js
// Modal component for premium upsell when user tries to assign task to AI

import React from 'react';
import { useNavigate } from 'react-router-dom';

// Placeholder Gumroad URL - replace with actual URL later
const GUMROAD_URL = 'https://withkana.gumroad.com/l/dsgkon';

function UpsellModal({ onClose }) {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    window.open(GUMROAD_URL, '_blank');
  };

  const handleAlreadyPurchased = () => {
    onClose();
    navigate('/settings');
  };

  // Close modal when clicking the overlay (background)
  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="upsell-modal-overlay" onClick={handleOverlayClick}>
      <div className="upsell-modal">
        <button className="upsell-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        
        <div className="upsell-modal-icon">🤖✨</div>
        
        <h2>Upgrade to Premium</h2>
        
        <p className="upsell-modal-description">
          AI task assignment is a premium feature. Upgrade to let your AI assistant 
          handle tasks like research, planning, and more — saving you hours every week.
        </p>

        <div className="upsell-modal-benefits">
          <div className="upsell-benefit">
            <span className="upsell-benefit-icon">🎯</span>
            <span>Delegate tasks to AI via email</span>
          </div>
          <div className="upsell-benefit">
            <span className="upsell-benefit-icon">👨‍👩‍👧‍👦</span>
            <span>Premium for entire family</span>
          </div>
          <div className="upsell-benefit">
            <span className="upsell-benefit-icon">⚡</span>
            <span>Instant activation</span>
          </div>
        </div>

        <button className="button button-primary upsell-upgrade-btn" onClick={handleUpgrade}>
          Upgrade Now
        </button>

        <button className="upsell-already-purchased" onClick={handleAlreadyPurchased}>
          I already purchased → Enter license code
        </button>
      </div>
    </div>
  );
}

export default UpsellModal;
